import {requestMs} from "@helpers/api";

export const trips = {
  getTrips: (query) => requestMs.get(`api3/user/${query}`),
  getSingleTrip: (carId, tripDate) => requestMs.get(`api3/car/${carId}/telemetry?date=${tripDate}`),
  updateSingleTrip: ({carId, tripId, data}) => requestMs.put(`api3/car/${carId}/telemetry/trip/${tripId}`, data),
  updateWholeTrip: ({ carId, data }) => requestMs.put(`api3/car/${carId}/telemetry/trip`, data),
};
